import scrollTo from '../../helpers/horizontal-scroll';
import GeoControlSearch from '../GeoControlSearch/GeoControlSearch';
import Popup from '../../UiKit/Elements/Popup/Popup';
import { updateScrollableNodeHeight } from '../../Funnel/helper';
import { geoControlFocusMobileInput } from '../focusHelper';

const TAG = 'local';
const KEYS = {
  MACRODISTRICT_ID: 'macrodistrict_id',
  DISTRICT_ID: 'district_id',
  MICRODISTRICT_ID: 'microdistrict_id',
  IS_NEAR_METRO: 'is_near_metro',
  SUBWAY_ROUTE_ID: 'subway_route_id',
  SUBWAY_ID: 'subway_id',
  DIRECTION_ID: 'direction_id',
  RAION_ID: 'raion_id',
}

const updateValue = (toggle, active) => {
  if (toggle.type === 'checkbox') {
    toggle.checked = active;
  } else if (active) {
    toggle.classList.add('-active');
  } else {
    toggle.classList.remove('-active');
  }
};

class GeoControlLocal {
  constructor(options = {}) {
    this.options = options;
    this.control = document.querySelector(`[data-uipopup-trigger="${TAG}"]`);
    if (!this.control) return;
    this.dropdown = document.querySelector(`[data-uipopup-for="${TAG}"]`);
    this.defaultList = this.dropdown.querySelector('[data-list="default"]');
    this.mobileDefaultList = this.defaultList.querySelector('[data-list="default-mobile"]');
    this.input = this.control.querySelector('input');
    this.inputParent = this.input.parentElement;
    this.chipsParent = this.control.querySelector('[data-chips]');
    this.banks = window.params.bank;
    this.routes = window.params.subwayRoutes;
    this.scrollParent = this.control.querySelector('[data-scroll]');
    this.activeToggles = {};
    this.activeChips = this.chipsParent
      ? [...this.chipsParent.querySelectorAll('[data-chip]')]
      : [];
    this.onToggle = options.onToggle;
    this.onAssign = options.onAssign;
    this.onReset = options.onReset;

    this.initSearch();
    if (this.mobileDefaultList && !options.initOnlySearch) this.attachListeners();
  }

  initSearch() {
    const resultsList = this.dropdown.querySelector('[data-list="results"]');
    const mobileInput = this.dropdown.querySelector('[data-search="field"]');
    const action = '/api/autocomplete-main';

    this.localPopup = new Popup(TAG, {
      onClose: () => {
        setTimeout(() => {
          this.defaultList.querySelector('[data-geo-scrollable]').scrollTop = 0;
        }, 400);
      },
      closeOnTriggerClick: false,
      disablePopperState: true,
      placement: 'bottom-start',
      disableScrollToPosition: window.screen.width > 725,
      onOpen() {
        geoControlFocusMobileInput(mobileInput);
        updateScrollableNodeHeight();
      },
    });

    new GeoControlSearch({
      action,
      input: mobileInput,
      defaultList: this.mobileDefaultList,
      resultsList: this.defaultList.querySelector('[data-list="results-mobile"]'),
      onSelect: this.options.onSelect,
      close: () => {
        this.localPopup.close();
      },
      parent: mobileInput.parentNode,
    });

    this.localSearchConfig = {
      action,
      resultsList,
      defaultList: this.defaultList,
      clearButton: this.control.querySelector('[data-clear]'),
      onSelect: this.options.onSelect,
      close: () => {
        this.localPopup.close();
      },
      parent: this.control,
      onBlur: null,
    };

    this.desktopSearch = new GeoControlSearch({
      ...this.localSearchConfig,
      input: this.input,
    });

    this.initCitySearch();
  }

  initCitySearch() {
    const CITY_TAG = 'search-bar-city-select';
    this.cityElement = this.control.querySelector('.GeoControlLocal-city');
    const cityDropdown = document.querySelector(`[data-uipopup-for="${CITY_TAG}"]`);
    if (!this.cityElement || !cityDropdown) return;

    this.mode = 'local';
    this.localPlaceholder = this.input.getAttribute('placeholder');
    this.currentGeo = this.cityElement.getAttribute('data-current-geo');

    this.cityPopup = new Popup(CITY_TAG, {
      closeOnTriggerClick: false,
      disablePopperState: true,
      placement: 'bottom-start',
      disableScrollToPosition: window.screen.width > 725,
      onClose: () => this.setMode('local'),
      onOpen() {
        updateScrollableNodeHeight();
      },
    });

    this.citySearchConfig = {
      action: '/api/autocomplete-city',
      resultsList: cityDropdown.querySelector('[data-list="results"]'),
      defaultList: cityDropdown.querySelector('[data-list="default"]'),
      clearButton: this.control.querySelector('[data-clear]'),
      close: () => this.cityPopup.close(),
      parent: this.control,
      onBlur: () => {
        this.input.value = '';
      },
    };

    this.cityElement.addEventListener(
      'click',
      (event) => {
        event.stopPropagation();
        if (this.localPopup.opened || this.cityPopup.opened) return;
        this.setMode('city');
        this.cityPopup.open();
        this.input.focus();
      },
      true,
    );

    this.input.addEventListener('click', (event) => {
      if (this.localPopup.opened || this.cityPopup.opened) {
        event.stopPropagation();
      }
    });
  }

  setMode(mode) {
    if (this.mode === mode) return;
    this.mode = mode;
    const isCity = mode === 'city';
    this.control.classList.toggle('-city-mode', isCity);
    this.control.classList.toggle('-active', isCity);
    this.input.value = '';
    if (isCity) {
      this.input.setAttribute('data-current-geo', this.currentGeo);
      this.input.setAttribute('placeholder', this.currentGeo);
    } else {
      this.input.removeAttribute('data-current-geo');
      this.input.setAttribute('placeholder', this.localPlaceholder);
    }
    this.desktopSearch.updateConfig(isCity ? this.citySearchConfig : this.localSearchConfig);
  }

  attachListeners() {
    this.subway = this.defaultList.querySelector('[data-geo="subway"]');
    this.districts = this.defaultList.querySelector('[data-geo="districts"]');
    this.resetButton = this.dropdown.querySelector('[data-reset]');

    if (this.districts) this.initToggles(this.districts.querySelectorAll('[data-toggle]'));
    if (this.subway) {
      this.initToggles(this.subway.querySelectorAll('[data-toggle]'));
    }
    [].forEach.call(this.activeChips, (chip) => {
      const icon = chip.querySelector('img');
      chip.addEventListener('click', (event) => {
        if (icon.contains(event.target)) {
          const [key, value] = chip.getAttribute('data-chip').split('|');
          this.resetChip(this.getToggle(key, value), key, value);
        } else {
          scrollTo(this.scrollParent, this.inputParent.offsetLeft, 500, () => this.input.focus());
        }
      });
    });
    this.resetButton.addEventListener('click', () => {
      this.reset();
    });
  }

  initToggles(toggles) {
    [].forEach.call(toggles, (toggle) => {
      const [key, value] = toggle.getAttribute('data-toggle').split('|');
      this.activeToggles[key] = window.params.initialQuery[key];
      toggle.addEventListener('click', (event) => {
        if (toggle.type !== 'checkbox') {
          event.preventDefault();
          toggle.classList.toggle('-active');
        }
        this.handleToggle(key, value, toggle.checked || toggle.classList.contains('-active'));
      });
    });
  }

  handleToggle(key, value, active) {
    switch (key) {
      case KEYS.MACRODISTRICT_ID:
        this.handleToggleWithRelations(key, value, active, [], [KEYS.DISTRICT_ID], this.banks);
        break;
      case KEYS.DISTRICT_ID:
        if (Object.keys(this.banks).length) {
          this.handleToggleWithRelations(key, value, active, [KEYS.MACRODISTRICT_ID], [], this.banks);
        } else {
          this.handleToggleDefault(key, value, active);
        }
        break;
      case KEYS.IS_NEAR_METRO:
        this.handleToggleWithRelations(
          key,
          value,
          active,
          [],
          [KEYS.SUBWAY_ROUTE_ID, KEYS.SUBWAY_ID],
          this.routes,
        );
        break;
      case KEYS.SUBWAY_ROUTE_ID:
        this.handleToggleWithRelations(
          key,
          value,
          active,
          [KEYS.IS_NEAR_METRO],
          [KEYS.SUBWAY_ID],
          this.routes,
        );
        break;
      case KEYS.SUBWAY_ID:
        if (Object.keys(this.routes).length) {
          this.handleToggleWithRelations(
            key,
            value,
            active,
            [KEYS.SUBWAY_ROUTE_ID, KEYS.IS_NEAR_METRO],
            [],
            this.routes,
          );
        } else {
          this.handleToggleDefault(key, value, active);
        }
        break;
      default:
        this.handleToggleDefault(key, value, active);
    }
  }

  handleToggleWithRelations(key, value, active, parents, children, relations) {
    let parentIds = [];
    let activeParentChip;

    this.activeToggles[key] = this.updateToggles(this.activeToggles[key], value);
    parents.forEach((parent, index) => {
      const relation = relations[parent];
      const idsCount = parentIds.length;
      const [currentKey, currentValue] =
        index === 0 ? [key, value] : [parents[idsCount - 1], parentIds[idsCount - 1]];
      const parentId = Object.keys(relation).find((id) => relation[id].includes(currentValue));
      const parentToggle = this.getToggle(parent, parentId);
      const parentIsActive = parentToggle.classList.contains('-active') || parentToggle.checked;
      const relatedIds = relation[parentId];
      parentIds = [...parentIds, parentId];
      if (relatedIds.every((id) => this.activeToggles[currentKey].indexOf(id) !== -1)) {
        this.activeToggles[parent] = this.updateToggles(this.activeToggles[parent], parentId);
        this.activeToggles[currentKey] = this.activeToggles[currentKey].filter((id) => {
          if (relatedIds.includes(id)) {
            this.removeChip(currentKey, id);
          }
          return !relatedIds.includes(id);
        });
        updateValue(parentToggle, !parentIsActive);
        activeParentChip = [parent, parentId];
      } else if (parentIsActive) {
        this.activeToggles[parent] = this.updateToggles(this.activeToggles[parent], parentId);
        this.removeChip(parent, parentId);
        this.activeToggles[currentKey] = this.updateToggles(
          this.activeToggles[currentKey],
          currentValue,
        );
        this.activeToggles[currentKey] = this.updateToggles(
          this.activeToggles[currentKey],
          relatedIds.filter((id) => {
            if (currentValue !== id) {
              this.createChip(currentKey, id);
            }
            return currentValue !== id;
          }),
        );
        updateValue(parentToggle, !parentIsActive);
      }
    });

    children.forEach((child, index) => {
      const currentKey = index === 0 ? key : children[index - 1];
      const relation = relations[currentKey];
      const currentValues = index === 0 ? [value] : Object.keys(relation);
      currentValues.forEach((currentValue) => {
        const relatedIds = relation[currentValue];
        this.activeToggles[child] = this.activeToggles[child].filter((id) => {
          if (relatedIds.includes(id)) {
            this.removeChip(child, id);
          }
          return !relatedIds.includes(id);
        });
        relatedIds.forEach((id) => updateValue(this.getToggle(child, id), active));
      });
    });

    if (activeParentChip && active) {
      const [activeParentKey, activeParentValue] = activeParentChip;
      this.createChip(activeParentKey, activeParentValue);
    } else if (active) {
      this.createChip(key, value);
    } else {
      this.removeChip(key, value);
    }

    this.onReset(this.activeToggles, true);
  }

  handleToggleDefault(key, value, active) {
    if (active) {
      this.createChip(key, value);
    } else {
      this.removeChip(key, value);
    }
    this.activeToggles[key] = this.updateToggles(this.activeToggles[key], value);

    this.onToggle(key, value, true);
  }

  createChip(key, value) {
    const toggle = this.getToggle(key, value);
    const chip = document.createElement('div');
    const chipContent = document.createElement('div');
    const iconParent = document.createElement('div');
    const icon = document.createElement('img');
    chip.classList.add('ChipRefresh');
    chip.classList.add('-active');
    chipContent.textContent = toggle.getAttribute('data-title');
    icon.src = '/images/close.svg';
    iconParent.classList.add('ChipRefresh-icon');
    iconParent.appendChild(icon);
    chip.appendChild(chipContent);
    chip.appendChild(iconParent);
    chip.setAttribute('data-chip', `${key}|${value}`);
    chip.addEventListener('click', (event) => {
      if (iconParent.contains(event.target)) {
        this.resetChip(toggle, key, value);
      } else {
        scrollTo(this.scrollParent, this.inputParent.offsetLeft, 500, () => this.input.focus());
      }
    });
    this.chipsParent.appendChild(chip);
    this.activeChips = [...this.activeChips, chip];
    this.chipsParent.classList.remove('hidden');
    scrollTo(this.scrollParent, this.inputParent.offsetLeft, 500);
  }

  removeChip(key, value) {
    this.activeChips = this.activeChips.filter((chip) => {
      if (chip.getAttribute('data-chip') === `${key}|${value}`) {
        this.chipsParent.removeChild(chip);
      }
      return chip.getAttribute('data-chip') !== `${key}|${value}`;
    });
    if (this.activeChips.length === 0) this.chipsParent.classList.add('hidden');
  }

  resetChip(toggle, key, value) {
    if (!toggle) {
      this.removeChip(key, value);
      this.onAssign(key, null, true);
      return;
    }

    if (toggle.type === 'checkbox') {
      toggle.checked = false;
    } else {
      toggle.classList.remove('-active');
    }
    this.handleToggle(key, value, false);
  }

  updateToggles(params, value) {
    if (!Array.isArray(params)) {
      params = params ? null : value;
    } else if (params.indexOf(value) !== -1) {
      params = params.filter((id) => value !== id);
    } else if (Array.isArray(value)) {
      params = [...params, ...value];
    } else {
      params = [...params, value];
    }
    return params;
  }

  getToggle(key, value) {
    return this.defaultList.querySelector(`[data-toggle="${key}|${value}"]`);
  }

  count() {
    let subwayCount = 0;
    let districtsCount = 0;
    let microdistrictsCount = 0;
    let directionsCount = 0;
    let raionsCount = 0;

    Object.entries(this.activeToggles).forEach(([key, value]) => {
      switch (key) {
        case KEYS.IS_NEAR_METRO:
          if (value) {
            this.routes[key][value].forEach((route) => {
              subwayCount += this.routes[KEYS.SUBWAY_ROUTE_ID][route].length;
            });
          }
          break;
        case KEYS.SUBWAY_ROUTE_ID:
          value.forEach((v) => {
            subwayCount += this.routes[key][v].length;
          })
          break;
        case KEYS.SUBWAY_ID:
          subwayCount += value.length;
          break;
        case KEYS.MACRODISTRICT_ID:
          value.forEach((v) => {
            districtsCount += this.banks[key][v].length;
          })
          break;
        case KEYS.DISTRICT_ID:
          districtsCount += value.length;
          break;
        case KEYS.MICRODISTRICT_ID:
          microdistrictsCount += value.length;
          break;
        case KEYS.DIRECTION_ID:
          directionsCount += value.length;
          break;
        case KEYS.RAION_ID:
          raionsCount += value.length;
          break;
      }
    });

    return {
      subway: subwayCount,
      districts: districtsCount,
      microdistricts: microdistrictsCount,
      directions: directionsCount,
      raions: raionsCount,
    };
  }

  reset() {
    if (!this.defaultList) return;
    const resetKeys = {};
    const toggles = [...this.defaultList.querySelectorAll('[data-toggle]:not([type="checkbox"])')];
    [].forEach.call(toggles, (toggle) => {
      const [key] = toggle.getAttribute('data-toggle').split('|');
      toggle.classList.remove('-active');
      resetKeys[key] = [];
    });
    const checkboxes = this.defaultList.querySelectorAll('[type="checkbox"]');
    [].forEach.call(checkboxes, (checkbox) => {
      const [key] = checkbox.getAttribute('data-toggle').split('|');
      checkbox.checked = false;
      if (key === KEYS.IS_NEAR_METRO) {
        resetKeys[key] = null;
      } else {
        resetKeys[key] = [];
      }
    });
    [].forEach.call(this.activeChips, (chip) => this.chipsParent.removeChild(chip));
    this.activeChips = [];
    this.chipsParent.classList.add('hidden');
    this.activeToggles = { ...resetKeys };
    this.onReset(resetKeys, true);
  }
}

export default GeoControlLocal;
